import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { h5PageCount } from 'ThreeTerminal_utils';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import TvFeed from '../tvFeed';

class TvTheater extends React.PureComponent {
    static propTypes = {
        hitTv2: PropTypes.object,
        isVideoShare: PropTypes.bool,
    };

    callAppHandle = (isSendCount = true, isJumpQQlink = false, isCallAppWx = true) => {
        if (isSendCount) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'phmovietopic',
                    other: {
                        url: encodeURIComponent(location.href),
                    },
                },
            ]);
        }

        if (isCallAppWx) {
            callApp({
                docType: 'web',
                pid: 'https://phtv.ifeng.com/loc/tvTheater?immersion=true',
                kind: 'share52209',
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1526325324255',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8982',
                isJumpQQlink,
            });
        }
    };

    render() {
        const { hitTv2, isVideoShare } = this.props;
        const { title = '', list = [] } = hitTv2;
        const schemeLink = getSchemeLink({
            docType: 'web',
            pid: 'https://phtv.ifeng.com/loc/tvTheater?immersion=true',
            kind: 'share52209',
        });

        return (
            <section className={styles.hot}>
                <div className={styles.toolbar} onClick={this.callAppHandle}>
                    <div className={styles.partTitle}>{title}</div>
                    <div className={styles.partMore}>打开app阅读</div>
                    {!isVideoShare && (
                        <WxLaunchApp
                            launchType="app"
                            launchAppClick={this.callAppHandle.bind(this, true, false, false)}
                            schemeLink={schemeLink}
                            launchAppFail={this.callAppHandle.bind(this, false, true, true)}
                        />
                    )}
                </div>
                <div className={styles.videoList}>
                    <TvFeed content={list} moduleName="tvSideslip" isVideoShare={isVideoShare} />
                </div>
            </section>
        );
    }
}

export default errorBoundary(TvTheater);
